import { EGuardEntityName, ITableColumn } from '~/core/models'
import { forecastPercentNumber } from '~/utils/index'

export const DISPLAYED_COLUMNS = [
  'numberOfSell',
  'epsWeBeatThem',
  'revWeBeatThem',
  'epsErrorReduction',
  'revErrorReduction',
  'companyCount',
]

export const ANALYST_COVERAGE_COLUMNS: ITableColumn[] = [
  {
    name: 'epsWeBeatThem',
    key: 'epsWeBeatThem',
    isTotalColumn: true,
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.epsWeBeatThem',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'revWeBeatThem',
    key: 'revWeBeatThem',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.revWeBeatThem',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'epsErrorReduction',
    key: 'epsErrorReduction',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.epsErrorReduction',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'revErrorReduction',
    key: 'revErrorReduction',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.revErrorReduction',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'companyCount',
    key: 'companyCount',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.companyCount',
    classes: { 'text-center': true, 'no-wrap': true },
  },
]
